import { Button } from "ui/button";
import { DataGrid, TableLoader } from "ui/data-grid";
import { ConfirmationDialog } from "ui/confirmation-dialog";
import SmsSimulatorRuleModal from "containers/sms-simulator/sms-simulator-rules/components/sms-simulator-rules-modal";

import { useSmsSimulatorRules } from "containers/sms-simulator/sms-simulator-rules/use-sms-simulator-rules";

import { SMS_SIMULATOR_STYLES } from "containers/sms-simulator/sms-simulator.styles";

export const SmsSimulatorRules = () => {
  const {
    rules,
    isRulesLoading,
    isModalOpen,
    selectedRule,
    isDeleteModalOpen,
    columns,
    handleReorder,
    handleConfirmDelete,
    handleSubmitRule,
    handleOpenAddModal,
    handleCloseModal,
    handleCloseDeleteModal,
  } = useSmsSimulatorRules();

  return (
    <div className="flex flex-col">
      <div className="flex flex-col items-start bg-gray-100 pl-9 pr-10">
        <div className="flex w-full justify-between items-center pt-5 pb-5">
          <h2 className={SMS_SIMULATOR_STYLES.heading}>Rules</h2>
          <Button onClick={handleOpenAddModal}>Add SMS Rule</Button>
        </div>
      </div>
      <div className="px-8 pb-8 overflow-y-scroll custom-scroll max-h-[80vh]">
        <TableLoader isLoading={isRulesLoading} fullScreen />

        {!isRulesLoading && rules.length ? (
          <DataGrid
            columns={columns}
            data={rules}
            isLoading={false}
            pagination={false}
            manualSorting={false}
            isDraggable={true}
            onReorder={handleReorder}
            draggableId="id"
            tableId="sms-simulator-rules"
          />
        ) : (
          !isRulesLoading && (
            <p className="text-gray-600 font-semibold">There are no rules in the list.</p>
          )
        )}
      </div>

      <SmsSimulatorRuleModal
        isOpen={isModalOpen}
        setIsOpen={handleCloseModal}
        onSubmit={handleSubmitRule}
        selectedRule={selectedRule}
      />

      <ConfirmationDialog
        open={isDeleteModalOpen}
        onClose={handleCloseDeleteModal}
        onConfirm={handleConfirmDelete}
        headline="Delete SMS Rule"
        message="Are you sure you want to delete this rule?"
        confirmButtonText="Submit"
        intent="warning"
      />
    </div>
  );
};

export default SmsSimulatorRules;
